export default __webpack_public_path__ + "static/wydzia-psychologii-w-sopocie_logo_horizontal_bt-522bc3d9105e50f4be03b99a924171bd.png";